import Mockman from "mockman-js";

const MockAPI=()=>{
    return (<div className="MockAPI">
        <Mockman/>
    </div>)
}

export default MockAPI;